<template>
  <div class="bg-white main-page">
    <div class="f-e-c">
      <el-button @click="visible=true">驳回</el-button>
      <el-button type="primary" @click="pass">通过</el-button>
    </div>
    <div class="info f">
      <span class="label">First Name：</span>
      <span>{{certificationForm.first}}</span>
    </div>
    <div class="info f">
      <span class="label">Last Name：</span>
      <span>{{certificationForm.last}}</span>
    </div>
    <div class="info f">
      <span class="label">Seller Permit Number： </span>
      <span>{{certificationForm.sellerPermit}}</span>
    </div>
    <div class="info f">
      <span class="label">Company Name： </span>
      <span>{{certificationForm.companyName}}</span>
    </div>
    <!-- <div class="info f">
      <span class="label">Email： </span>
      <span>{{certificationForm.email}}</span>
    </div> -->
    <div class="info f">
      <span class="label">Do you sell online： </span>
      <div>
        <span>{{certificationForm.ifSellOnline===1?'是':'否'}}</span><br>
        <span>{{certificationForm.storeUrl}}</span>
      </div>
    </div>
    <div class="info f">
      <span class="label">Store Picture： </span>
      <el-image fit="contain" v-if="certificationForm.storePicture&&certificationForm.storePicture!==''" style="width:104px;height:104px;" :src="certificationForm.storePicture" :preview-src-list="[certificationForm.storePicture]"> </el-image>
    </div>
    <div class="info f">
      <span class="label">Document of Proof： </span>
      <div class="f" style="margin:10px 0">
        <div v-for="(item,index) in documentFiles" :key="index" class="upload-demo-box">
          <div class="storePicture pointer fd-c f-c-c">
            <img v-if="item.type==='docx'" src="@/assets/img/word.png" alt="" @click="seeDocument(item.url)">
            <img v-else-if="item.type==='gif'" src="@/assets/img/GIF.png" alt="" @click="seeDocument(item.url)">
            <img v-else-if="item.type==='pdf'" src="@/assets/img/Pdf.png" alt="" @click="seeDocument(item.url)">
            <el-image v-else-if="item.url&&item.url!==''" fit="contain" style="width: 63px; height: 63px" :src="item.url" :preview-src-list="[item.url]">
            </el-image>
            <div>点击查看</div>
          </div>
        </div>
      </div>
    </div>
    <div class="info f">
      <span class="label"> Address：</span>
      <span>{{certificationForm.address}}</span>
    </div>
    <div class="info f">
      <span class="label">City： </span>
      <span>{{certificationForm.city}}</span>
    </div>
    <div class="info f">
      <span class="label">State/Province： </span>
      <span>{{certificationForm.stateOrProvince}}</span>
    </div>
    <div class="info f">
      <span class="label">ZIP/Postal Code： </span>
      <span>{{certificationForm.ipOrPostalCode}}</span>
    </div>
    <div class="info f">
      <span class="label">Country： </span>
      <span>{{certificationForm.country}}</span>
    </div>
    <div class="info f">
      <span class="label">Phone： </span>
      <span>{{certificationForm.phone}}</span>
    </div>
    <el-dialog title="驳回" :visible.sync="visible" :closeOnClickModal="false" @close="close" width="30%">
      <el-form ref="auditForm" :model="auditForm" label-width="0px" :rules="rules">
        <el-form-item label="" prop="reasonForRejection">
          <el-input type="textarea" placeholder="请输入驳回原因,用英文表达" v-model="auditForm.reasonForRejection"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="close">取 消</el-button>
        <el-button :loading="loading" type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import { matchChinese } from '@/utils/validate'
let english = (rule, value, callback) => {
  if (!matchChinese(value)) {
    callback()
  } else {
    callback(new Error('请输入英文或符号'))
  }
}
export default {
  data() {
    return {
      certificationForm: {},
      rules: {
        reasonForRejection: [{ required: true, validator: english, trigger: 'change' }]
      },
      loading: false,
      visible: false,
      documentFiles: [],
      auditForm: {}
    }
  },
  created() {
    this.getUserCertification()
  },
  methods: {
    getUserCertification() {
      API.getUserCertification(this.$route.query.id).then(res => {
        this.certificationForm = res.data || {}
        res.data.documentOfProofUrl && res.data.documentOfProofUrl.split(',').forEach((item, index) => {
          this.documentFiles[index] = { url: item, type: item.split('.')[item.split('.').length - 1] }
        })
      })
    },
    submit() {
      this.$refs.auditForm.validate(valid => {
        if (!valid) return
        this.auditForm.approvalStatus = 2
        this.certificationAuditCustomer()
      })
    },
    certificationAuditCustomer() {
      this.auditForm.id = this.certificationForm.id
      API.certificationAuditCustomer(this.auditForm).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success(`${this.certificationForm.approvalStatus === 2 ? '驳回成功' : '认证通过'}`)
        this.close()
        this.getUserCertification()
        this.$router.push('/customer/management')
      })
    },
    pass() {
      this.$confirm('是否确定通过此客户提交的资质认证资料', '通过', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: "warning"
      }).then(() => {
        this.auditForm.approvalStatus = 3
        this.certificationAuditCustomer()
      }).catch(() => {
        this.close()
      });

    },
    close() {
      this.visible = false
      this.auditForm = {}
      // this.$refs.auditForm.clearValidate()
    },
    seeDocument(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.storePicture {
  width: 104px;
  height: 110px;
  border: 1px dashed #c0ccda;
  position: relative;
  img {
    height: 63px;
    width: 63px;
  }
  text-align: center;
}
.upload-demo-box {
  margin-right: 15px;
  border-radius: 4px;
}
.main-page {
  padding: 10px 30px;
  min-height: calc(100vh - 60px);
}
.info {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #747a87;
  padding-bottom: 15px;
  .label {
    width: 180px;
    text-align: right;
  }
}
</style>